import React from 'react';
import {connect} from 'react-redux';

import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { SSelect } from '@avalara/skylab-sdk/react';

const log = new Logger('SINGLE_VATCODE_SELECTOR', LOG_LEVELS.DEBUG);

export class SingleVATCodeSelector extends React.Component {

    selectionChangeHandlerFactory(fieldName) {
        return (event) => {
            log.debug('selectionChangeHandlerFactory(%s): %s, ', fieldName, event);
            const newValue = event?.detail?.item?.value ?? '';
            log.debug('selectionChangeHandlerFactory(%s): oldValue: %s, newValue: %s  ', fieldName, this.props[fieldName], newValue);
            let selection = {};
            selection[fieldName] = newValue !== '' ? newValue : undefined;
            this.props.selectionHandler(selection);
        }
    }

    render() {
        log.debug('render(): ', this.props);
        const optionsList = [
            { label: 'Select VAT code', value: '' },
            ...((this.props.VATCodeList || []).map((vatcode, key) => ({
                label: vatcode,
                value: vatcode,
                selected: this.props.selectedVATCodeId === vatcode
            })))
        ];
        return (
            <SSelect
                inputId="vatcode-single-select"
                name="vatCodes"
                onS-select={this.selectionChangeHandlerFactory(this.props.fieldName).bind(this)}
                optionsList={optionsList}
                multiple={false}
                showSelectionCount={false}
            />
        )
    }
}




// Wrap the component to inject state into it
export default (SingleVATCodeSelector);